import styled from 'styled-components';
import { Row, Col, FlexView } from '@cuemath/comps';
import { Text } from '@cuemath/web-comps';
import { SA_COLORS } from '../../styled-comps';
import { SENIOR_ROLES } from '../../constants';

// ── View Tabs ─────────────────────────────────────────────────────────
export const ViewTabsRow = styled(Row)`
  && {
    width: 100%;
    height: 52px;
    border-bottom: 1px solid ${SA_COLORS.BORDER_SECONDARY};
  }
`;

export const ViewTab = styled.button`
  flex: ${({ $fixed }) => ($fixed ? '0 0 48px' : '1')};
  padding: 16px 0px 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${({ $active }) =>
    $active ? SA_COLORS.TEXT_PRIMARY : SA_COLORS.TEXT_SECONDARY};
  background: transparent;
  border: none;
  border-bottom: 2px solid
    ${({ $active }) => ($active ? SA_COLORS.NEUTRAL_1000 : 'transparent')};
  cursor: pointer;
  text-align: center;
  transition: all 150ms;

  &:hover {
    color: ${SA_COLORS.TEXT_PRIMARY};
    background: ${SA_COLORS.BG_SECONDARY};
  }
`;

// ── Shared across views ───────────────────────────────────────────────
export const TicketListInner = styled(Col)`
  && {
    padding: 0 8px 8px;
  }
`;

export const EmptySearch = styled(FlexView)`
  && {
    align-items: center;
    justify-content: center;
    padding-top: 48px;
    text-align: center;
    gap: 12px;
  }
`;

export const EmptyTitle = styled(Text)`
  && {
    font-size: 14px;
    font-weight: 600;
    color: ${SA_COLORS.TEXT_PRIMARY};
  }
`;

export const EmptySub = styled(Text)`
  && {
    font-size: 12px;
    color: ${SA_COLORS.TEXT_TERTIARY};
  }
`;

export const FilterErrorMsg = styled(Text)`
  && {
    font-size: 11px;
    color: ${SA_COLORS.ERROR_600};
    padding: 4px 12px;
  }
`;

export const AgentBadge = styled(Text)`
  && {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 10px;
    color: ${SA_COLORS.TEXT_TERTIARY};
    padding: 2px 5px;
    background: ${SA_COLORS.BG_SECONDARY};
    border: 1px solid ${SA_COLORS.BORDER_TERTIARY};
  }
`;

export const TeamBadge = styled(Text)`
  && {
    display: inline-flex;
    align-items: center;
    font-size: 10px;
    color: ${SA_COLORS.TEXT_SECONDARY};
    padding: 2px 7px;
    background: ${SA_COLORS.BG_SECONDARY};
    border: 1px solid ${SA_COLORS.BORDER_TERTIARY};
  }
`;

export const TicketMetaRow = styled(Row)`
  && {
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
  }
`;

// ── Inbox: Filter styled components ───────────────────────────────────
export const FacetBtnWrap = styled(Col)`
  && {
    position: relative;
  }
`;

export const FacetOptionRow = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 13px;
  color: ${SA_COLORS.TEXT_PRIMARY};

  &:hover {
    background: ${SA_COLORS.BG_SECONDARY};
  }
`;

export const FacetCheckbox = styled.span`
  width: 16px;
  height: 16px;
  border: 1px solid
    ${({ $checked }) => ($checked ? SA_COLORS.GOLD_500 : SA_COLORS.BORDER_PRIMARY)};
  background: ${({ $checked }) => ($checked ? SA_COLORS.GOLD_500 : 'transparent')};
  display: grid;
  place-items: center;
  flex-shrink: 0;
  color: white;
`;

export const AppliedRow = styled(Row)`
  && {
    flex-wrap: wrap;
    gap: 6px;
    align-items: center;
  }
`;

export const ChipClose = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: inline-flex;
  align-items: center;
  color: ${SA_COLORS.GOLD_700};
  font-size: 14px;
  line-height: 1;
`;

export const ClearBtn = styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 11px;
  color: ${SA_COLORS.TEXT_TERTIARY};
  font-weight: 600;

  &:hover {
    color: ${SA_COLORS.TEXT_PRIMARY};
  }
`;

export const FilterActions = styled(Row)`
  && {
    gap: 2px;
    opacity: 0;
    transition: opacity 150ms;
  }
`;

export const FilterItemWrap = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 12px;
  background: ${({ $active }) => ($active ? SA_COLORS.NEUTRAL_1000 : 'none')};
  color: ${({ $active }) => ($active ? 'white' : SA_COLORS.TEXT_PRIMARY)};
  border: none;
  font-size: 13px;
  text-align: left;
  cursor: pointer;
  transition: background 150ms;

  &:hover {
    background: ${({ $active }) =>
      $active ? SA_COLORS.NEUTRAL_1000 : SA_COLORS.BG_SECONDARY};
  }

  &:hover ${FilterActions} {
    opacity: 1;
  }
`;

export const FilterActionBtn = styled.button`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  cursor: pointer;
  color: ${({ $active }) =>
    $active ? 'rgba(255,255,255,0.7)' : SA_COLORS.TEXT_TERTIARY};

  &:hover {
    color: ${({ $active }) => ($active ? 'white' : SA_COLORS.TEXT_PRIMARY)};
  }
`;

export const RenameInput = styled.input`
  flex: 1;
  padding: 4px 8px;
  font-size: 13px;
  border: 1px solid ${SA_COLORS.GOLD_500};
  background: ${SA_COLORS.BG_PRIMARY};
  color: ${SA_COLORS.TEXT_PRIMARY};
  outline: none;
`;

export const SaveBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
  padding: 3px 7px;
  font-size: 11px;
  font-weight: 500;
  color: ${SA_COLORS.GOLD_700};
  background: ${SA_COLORS.GOLD_50};
  border: 1px solid ${SA_COLORS.GOLD_300};
  cursor: pointer;

  &:hover {
    filter: brightness(0.95);
  }
`;

export const SavePopover = styled(FlexView)`
  && {
    padding: 10px;
    background: ${SA_COLORS.BG_SECONDARY};
    border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
    margin-top: 8px;
  }
`;

export const SaveInput = styled.input`
  width: 100%;
  padding: 6px 8px;
  font-size: 13px;
  background: ${SA_COLORS.BG_PRIMARY};
  border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
  color: ${SA_COLORS.TEXT_PRIMARY};
  outline: none;

  &:focus {
    border-color: ${SA_COLORS.GOLD_500};
  }
`;

export const SaveActions = styled(Row)`
  && {
    justify-content: flex-end;
    gap: 6px;
    margin-top: 8px;
  }
`;

export const SaveActionBtn = styled.button`
  font-size: 12px;
  padding: 5px 10px;
  border: 1px solid ${SA_COLORS.BORDER_TERTIARY};
  color: ${({ $primary }) => ($primary ? 'white' : SA_COLORS.TEXT_SECONDARY)};
  background: ${({ $primary }) =>
    $primary ? SA_COLORS.NEUTRAL_1000 : SA_COLORS.BG_PRIMARY};
  border-color: ${({ $primary }) =>
    $primary ? SA_COLORS.NEUTRAL_1000 : SA_COLORS.BORDER_TERTIARY};
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
  }
`;

export const AvailabilityLabel = styled(Text)`
  && {
    font-size: 12px;
    color: ${SA_COLORS.TEXT_TERTIARY};
  }
`;

export const WarningText = styled(Text)`
  && {
    font-size: 13px;
    color: ${SA_COLORS.WARNING_900};
  }
`;

export const FacetBadge = styled.span`
  min-width: 16px;
  height: 16px;
  padding: 0 4px;
  background: ${SA_COLORS.GOLD_500};
  color: white;
  font-size: 10px;
  font-weight: 700;
  display: grid;
  place-items: center;
`;

// ── Search Users styled components ────────────────────────────────────
export const SearchHeader = styled(FlexView)`
  && {
    flex: 0 0 auto;
    padding: 16px 16px 0;
    gap: 8px;
  }
`;

export const SearchScroll = styled(FlexView)`
  && {
    flex: 1 1 0;
    min-height: 0;
    overflow: auto;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: ${SA_COLORS.BORDER_PRIMARY};
    }
  }
`;

export const SearchScrollInner = styled(FlexView)`
  && {
    padding: 16px 12px 16px 16px;
    gap: 0;
  }
`;

export const SearchInputWrap = styled(Row)`
  && {
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: ${SA_COLORS.BG_SECONDARY};
    border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
  }
`;

export const SearchTextInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: ${SA_COLORS.TEXT_PRIMARY};
`;

export const ExpandArrow = styled.span`
  font-size: 12px;
  color: ${SA_COLORS.TEXT_TERTIARY};
  transition: transform 150ms;
  transform: ${({ $expanded }) => ($expanded ? 'rotate(90deg)' : 'rotate(0deg)')};
`;

// ── Inbox sort control (icon button inline with the search bar) ───────
export const SearchSortRow = styled(Row)`
  gap: 8px;
  margin: 0 8px 8px;

  /* Search input fills the row; the sort button keeps its fixed width. */
  > *:first-child {
    flex: 1;
  }
`;

export const SortWrap = styled(FlexView)`
  position: relative;
`;

export const SortBtn = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 38px;
  color: ${SA_COLORS.TEXT_PRIMARY};
  background: ${SA_COLORS.BG_SECONDARY};
  border: 1px solid
    ${({ $active }) => ($active ? SA_COLORS.TEXT_PRIMARY : SA_COLORS.BORDER_SECONDARY)};
  cursor: pointer;

  &:hover {
    background: ${SA_COLORS.BG_PRIMARY};
  }
`;

export const SortDot = styled.span`
  position: absolute;
  top: -4px;
  right: -4px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: ${SA_COLORS.GOLD_700};
  border: 1.5px solid ${SA_COLORS.BG_SECONDARY};
`;

export const SortMenu = styled(FlexView)`
  position: absolute;
  top: calc(100% + 4px);
  right: 0;
  width: 210px;
  z-index: 5;
  background: ${SA_COLORS.BG_SECONDARY};
  border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.14);
`;

export const SortMenuHeader = styled(FlexView)`
  padding: 8px 12px 6px;
  border-bottom: 1px solid ${SA_COLORS.BORDER_SECONDARY};
`;

export const SortMenuItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  background: ${({ $active }) => ($active ? SA_COLORS.BG_PRIMARY : 'transparent')};
  border: none;
  cursor: pointer;

  &:hover {
    background: ${SA_COLORS.BG_PRIMARY};
  }
`;

// ── User Search: Result Card ──────────────────────────────────────────
export const UserResultCard = styled(FlexView)`
  && {
    background: ${SA_COLORS.BG_PRIMARY};
    border: 1px solid
      ${({ $expanded }) => ($expanded ? SA_COLORS.GOLD_300 : SA_COLORS.BORDER_TERTIARY)};
    margin-bottom: 8px;
    overflow: hidden;
  }
`;

export const UserResultHeader = styled(Row)`
  && {
    padding: 12px 16px;
    align-items: center;
    gap: 12px;
    cursor: pointer;
    transition: background 0.15s;

    &:hover {
      background: ${SA_COLORS.BG_SECONDARY};
    }
  }
`;

export const UserResultName = styled(Text)`
  && {
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    color: ${SA_COLORS.TEXT_PRIMARY};
  }
`;

export const UserResultSummary = styled(Text)`
  && {
    font-size: 12px;
    color: ${SA_COLORS.TEXT_TERTIARY};
  }
`;

export const UserResultDetails = styled(FlexView)`
  && {
    padding: 12px 16px;
    border-top: 1px solid ${SA_COLORS.BORDER_TERTIARY};
    background: ${SA_COLORS.BG_SECONDARY};
    gap: 0;
  }
`;

export const UserDetailRow = styled(Row)`
  && {
    align-items: center;
    gap: 8px;
    padding: 6px 0;
    font-size: 13px;
  }
`;

export const UserDetailLabel = styled(Text)`
  && {
    color: ${SA_COLORS.TEXT_TERTIARY};
    min-width: 60px;
    font-size: 12px;
  }
`;

export const UserDetailValue = styled(Text)`
  && {
    flex: 1;
    color: ${SA_COLORS.TEXT_PRIMARY};
    font-family: monospace;
    font-size: 12px;
  }
`;

export const CopyBtn = styled.button`
  padding: 4px 6px;
  background: ${SA_COLORS.BG_PRIMARY};
  border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
  color: ${SA_COLORS.TEXT_TERTIARY};
  cursor: pointer;
  opacity: 0;
  transition: all 0.15s;
  display: inline-flex;
  align-items: center;
  flex-shrink: 0;

  ${UserDetailRow}:hover & {
    opacity: 1;
  }

  &:hover {
    background: ${SA_COLORS.BG_TERTIARY};
    color: ${SA_COLORS.TEXT_PRIMARY};
  }
`;

// ── User Search: Ticket Items ─────────────────────────────────────────
export const SearchTicketItem = styled(FlexView)`
  && {
    padding: 10px 12px;
    border: 1px solid ${SA_COLORS.BORDER_TERTIARY};
    margin-bottom: 6px;
    cursor: pointer;
    transition: all 0.15s;
    gap: 4px;

    &:hover {
      border-color: ${SA_COLORS.GOLD_300};
      background: ${SA_COLORS.BG_SECONDARY};
    }
  }
`;

export const TicketRow = styled(Row)`
  && {
    align-items: center;
    gap: 8px;
  }
`;

export const TicketIdMono = styled(Text)`
  && {
    font-size: 12px;
    font-weight: 600;
    color: ${SA_COLORS.TEXT_TERTIARY};
    font-family: monospace;
  }
`;

export const TicketStatusBadge = styled.span`
  font-size: 11px;
  padding: 2px 8px;
  font-weight: 600;
  text-transform: uppercase;
  background: ${SA_COLORS.BG_TERTIARY};
  color: ${SA_COLORS.TEXT_TERTIARY};

  ${({ $status }) => {
    const s = ($status || '').toUpperCase();
    if (s === 'RESOLVED')
      return `background: ${SA_COLORS.SUCCESS_100}; color: ${SA_COLORS.SUCCESS_700};`;
    if (s === 'ESCALATED')
      return `background: ${SA_COLORS.ERROR_100}; color: ${SA_COLORS.ERROR_700};`;
    if (s === 'OPEN')
      return `background: ${SA_COLORS.GOLD_50}; color: ${SA_COLORS.GOLD_700};`;
    return '';
  }}
`;

export const TicketSubjectText = styled(Text)`
  && {
    font-size: 13px;
    color: ${SA_COLORS.TEXT_PRIMARY};
    line-height: 1.4;
  }
`;

export const TicketTimeText = styled(Text)`
  && {
    font-size: 11px;
    color: ${SA_COLORS.TEXT_TERTIARY};
  }
`;

export const SearchBtn = styled.button`
  padding: 6px 12px;
  font-size: 13px;
  font-weight: 500;
  background: ${SA_COLORS.NEUTRAL_1000};
  color: ${SA_COLORS.NEUTRAL_100};
  border: none;
  cursor: pointer;
  transition: opacity 150ms;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const LoadMoreTicketsBtn = styled.button`
  width: 100%;
  padding: 8px;
  background: transparent;
  border: 1px dashed ${SA_COLORS.BORDER_PRIMARY};
  color: ${SA_COLORS.GOLD_700};
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  margin-top: 4px;

  &:hover {
    background: ${SA_COLORS.GOLD_50};
    border-color: ${SA_COLORS.GOLD_300};
  }
`;

export const UserTicketsSection = styled(FlexView)`
  && {
    border-top: 1px solid ${SA_COLORS.BORDER_TERTIARY};
    gap: 0;
  }
`;

export const UserTicketsHeader = styled(Text)`
  && {
    padding: 10px 16px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: ${SA_COLORS.TEXT_TERTIARY};
    background: ${SA_COLORS.BG_SECONDARY};
  }
`;

export const UserTicketsList = styled(FlexView)`
  && {
    padding: 8px;
    gap: 0;
  }
`;

// ── Agents (shared with Teams view) ───────────────────────────────────
export const AgentOnlineDot = styled.span`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: ${({ $online }) =>
    $online ? SA_COLORS.SUCCESS_600 : SA_COLORS.TEXT_TERTIARY};
  border: 2px solid ${SA_COLORS.BG_PRIMARY};
`;

export const AgentRoleBadge = styled(Text)`
  && {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 2px 6px;
    background: ${({ $role }) =>
      SENIOR_ROLES.indexOf($role) !== -1 ? SA_COLORS.GOLD_50 : SA_COLORS.BG_SECONDARY};
    color: ${({ $role }) =>
      SENIOR_ROLES.indexOf($role) !== -1 ? SA_COLORS.GOLD_700 : SA_COLORS.TEXT_SECONDARY};
  }
`;

// ── Add Agent Modal ──────────────────────────────────────────────────
export const AgentSearchResults = styled(FlexView)`
  && {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid ${SA_COLORS.BORDER_TERTIARY};
    margin-top: 8px;
    gap: 0;
  }
`;

export const AgentSearchItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 10px 12px;
  background: ${({ $selected }) => ($selected ? SA_COLORS.GOLD_50 : 'transparent')};
  border: none;
  border-bottom: 1px solid ${SA_COLORS.BORDER_TERTIARY};
  cursor: pointer;
  text-align: left;

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${({ $selected }) =>
      $selected ? SA_COLORS.GOLD_50 : SA_COLORS.BG_SECONDARY};
  }
`;

export const AgentSearchInfo = styled(FlexView)`
  && {
    flex: 1;
    min-width: 0;
    gap: 1px;
  }
`;

export const AgentSearchName = styled(Text)`
  && {
    font-size: 13px;
    font-weight: 600;
    color: ${SA_COLORS.TEXT_PRIMARY};
  }
`;

export const AgentSearchEmail = styled(Text)`
  && {
    font-size: 11px;
    color: ${SA_COLORS.TEXT_TERTIARY};
  }
`;

export const AgentSearchId = styled(Text)`
  && {
    font-size: 10px;
    color: ${SA_COLORS.TEXT_TERTIARY};
    font-family: monospace;
  }
`;

export const FormField = styled(FlexView)`
  && {
    gap: 6px;
    margin-top: 12px;
  }
`;

export const FormLabel = styled(Text)`
  && {
    font-size: 12px;
    font-weight: 600;
    color: ${SA_COLORS.TEXT_SECONDARY};
  }
`;

export const FormSelect = styled.select`
  padding: 8px 12px;
  font-size: 13px;
  border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
  background: ${SA_COLORS.BG_PRIMARY};
  color: ${SA_COLORS.TEXT_PRIMARY};
  outline: none;

  &:focus {
    border-color: ${SA_COLORS.GOLD_500};
  }
`;

export const ConfirmText = styled(Text)`
  && {
    font-size: 13px;
    line-height: 1.5;
    color: ${SA_COLORS.TEXT_SECONDARY};
  }
`;

export const ConfirmBoldName = styled(Text)`
  && {
    display: inline;
    font-weight: 700;
    color: ${SA_COLORS.TEXT_PRIMARY};
  }
`;

export const BtnDanger = styled.button`
  padding: 8px 16px;
  font-size: 13px;
  font-weight: 600;
  background: ${SA_COLORS.ERROR_600};
  color: white;
  border: none;
  cursor: pointer;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

// ── Teams view ───────────────────────────────────────────────────────
export const TeamsHeaderActions = styled(FlexView)`
  && {
    padding: 12px 12px 0;
    gap: 8px;
  }
`;

export const TeamHeaderBtn = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: 100%;
  padding: 10px 12px;
  font-size: 13px;
  font-weight: 600;
  background: ${({ $primary }) =>
    $primary ? SA_COLORS.GOLD_500 : SA_COLORS.BG_SECONDARY};
  color: ${({ $primary }) => ($primary ? SA_COLORS.NEUTRAL_100 : SA_COLORS.TEXT_PRIMARY)};
  border: 1px solid
    ${({ $primary }) => ($primary ? SA_COLORS.GOLD_500 : SA_COLORS.BORDER_SECONDARY)};
  cursor: pointer;

  &:hover {
    ${({ $primary }) =>
      $primary ? 'filter: brightness(1.05);' : `background: ${SA_COLORS.BG_TERTIARY};`}
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const TeamsList = styled(FlexView)`
  && {
    flex: 1;
    overflow-y: auto;
    padding: 12px;
    gap: 8px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-track {
      background: transparent;
    }

    &::-webkit-scrollbar-thumb {
      background: ${SA_COLORS.BORDER_PRIMARY};
    }
  }
`;

export const TeamCard = styled(FlexView)`
  && {
    border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
    background: ${SA_COLORS.BG_SECONDARY};
    gap: 0;
  }
`;

export const TeamHeader = styled(Row)`
  && {
    align-items: center;
    justify-content: space-between;
    padding: 12px;
    gap: 8px;
  }
`;

export const TeamExpandBtn = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
  min-width: 0;
  background: none;
  border: 0;
  padding: 0;
  cursor: pointer;
  text-align: left;
  color: ${SA_COLORS.TEXT_PRIMARY};
`;

export const TeamExpandChev = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  color: ${SA_COLORS.TEXT_TERTIARY};
  transition: transform 0.2s;
  transform: rotate(${({ $expanded }) => ($expanded ? 180 : 0)}deg);
`;

export const TeamName = styled(Text)`
  && {
    font-size: 14px;
    font-weight: 600;
    color: ${SA_COLORS.TEXT_PRIMARY};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1;
    min-width: 0;
  }
`;

export const TeamNameInput = styled.input`
  flex: 1;
  padding: 4px 8px;
  border: 1px solid ${SA_COLORS.GOLD_500};
  background: ${SA_COLORS.BG_PRIMARY};
  color: ${SA_COLORS.TEXT_PRIMARY};
  font-size: 14px;
  font-weight: 600;
  outline: none;
  min-width: 0;
`;

export const TeamCount = styled(Text)`
  && {
    font-size: 12px;
    color: ${SA_COLORS.TEXT_TERTIARY};
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

export const TeamActions = styled(Row)`
  && {
    gap: 4px;
    flex-shrink: 0;
  }
`;

export const TeamActionBtn = styled.button`
  display: grid;
  place-items: center;
  width: 24px;
  height: 24px;
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  color: ${SA_COLORS.TEXT_TERTIARY};

  &:hover {
    color: ${({ $danger }) => ($danger ? SA_COLORS.ERROR_600 : SA_COLORS.TEXT_PRIMARY)};
    background: ${({ $danger }) =>
      $danger ? SA_COLORS.ERROR_100 : SA_COLORS.BG_SECONDARY};
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const TeamBody = styled(FlexView)`
  && {
    border-top: 1px solid ${SA_COLORS.BORDER_SECONDARY};
    padding: 12px;
    background: ${SA_COLORS.BG_PRIMARY};
    gap: 8px;
  }
`;

export const TeamAgentsHeader = styled(Row)`
  && {
    justify-content: space-between;
    align-items: center;
  }
`;

export const TeamAgentsLabel = styled(Text)`
  && {
    font-size: 11px;
    font-weight: 600;
    color: ${SA_COLORS.TEXT_SECONDARY};
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
`;

export const TeamEmpty = styled(Text)`
  && {
    padding: 24px;
    text-align: center;
    font-size: 13px;
    color: ${SA_COLORS.TEXT_TERTIARY};
  }
`;

export const TeamAgentsList = styled(FlexView)`
  && {
    gap: 6px;
  }
`;

export const TeamAgentItem = styled(Row)`
  && {
    align-items: center;
    gap: 10px;
    padding: 10px;
    background: ${SA_COLORS.BG_SECONDARY};
    border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
  }
`;

export const TeamAgentAvatar = styled.span`
  position: relative;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: ${SA_COLORS.GOLD_100};
  color: ${SA_COLORS.GOLD_700};
  display: grid;
  place-items: center;
  font-weight: 600;
  font-size: 12px;
  flex-shrink: 0;
`;

export const TeamAgentInfo = styled(FlexView)`
  && {
    flex: 1;
    min-width: 0;
    gap: 2px;
  }
`;

export const TeamAgentName = styled(Text)`
  && {
    font-size: 13px;
    font-weight: 600;
    color: ${SA_COLORS.TEXT_PRIMARY};
  }
`;

export const TeamAgentEmail = styled(Text)`
  && {
    font-size: 11px;
    color: ${SA_COLORS.TEXT_SECONDARY};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const TeamAgentMeta = styled(Row)`
  && {
    gap: 6px;
    align-items: center;
    margin-top: 2px;
  }
`;

export const TeamAgentTickets = styled(Text)`
  && {
    font-size: 11px;
    color: ${SA_COLORS.TEXT_TERTIARY};
  }
`;

export const TeamAddAgentList = styled(FlexView)`
  && {
    gap: 6px;
    max-height: 400px;
    overflow-y: auto;
  }
`;

export const TeamAddAgentItem = styled.button`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: ${({ $selected }) =>
    $selected ? SA_COLORS.BG_SECONDARY : SA_COLORS.BG_PRIMARY};
  border: 1px solid
    ${({ $selected }) => ($selected ? SA_COLORS.SUCCESS_700 : SA_COLORS.BORDER_SECONDARY)};
  cursor: pointer;
  text-align: left;
  width: 100%;

  &:hover {
    background: ${SA_COLORS.BG_SECONDARY};
    border-color: ${SA_COLORS.GOLD_500};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

// ── Team multi-select picker (used by AddAgentModal) ─────────────────
export const TeamPickerWrap = styled(FlexView)`
  && {
    position: relative;
    gap: 4px;
  }
`;

export const TeamPickerTrigger = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid
    ${({ $error }) => ($error ? SA_COLORS.ERROR_600 : SA_COLORS.BORDER_SECONDARY)};
  background: ${SA_COLORS.BG_PRIMARY};
  color: ${SA_COLORS.TEXT_PRIMARY};
  font-size: 13px;
  cursor: pointer;
  text-align: left;

  &:hover {
    border-color: ${SA_COLORS.GOLD_500};
  }
`;

export const TeamPickerTriggerLabel = styled.span`
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: ${({ $placeholder }) =>
    $placeholder ? SA_COLORS.TEXT_TERTIARY : SA_COLORS.TEXT_PRIMARY};
`;

export const TeamPickerMenu = styled(FlexView)`
  && {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: ${SA_COLORS.BG_PRIMARY};
    border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    max-height: 240px;
    overflow-y: auto;
    z-index: 100;
    gap: 0;
  }
`;

export const TeamPickerItem = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  color: ${SA_COLORS.TEXT_PRIMARY};
  border-bottom: 1px solid ${SA_COLORS.BORDER_TERTIARY};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${SA_COLORS.BG_SECONDARY};
  }

  & > input[type='checkbox'] {
    width: 16px;
    height: 16px;
    cursor: pointer;
    accent-color: ${SA_COLORS.GOLD_500};
  }
`;

export const RolePickerItem = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 10px;
  padding: 8px 12px;
  cursor: pointer;
  font-size: 13px;
  text-align: left;
  background: ${({ $selected }) =>
    $selected ? SA_COLORS.BG_SECONDARY : SA_COLORS.BG_PRIMARY};
  color: ${SA_COLORS.TEXT_PRIMARY};
  border: none;
  border-bottom: 1px solid ${SA_COLORS.BORDER_TERTIARY};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${SA_COLORS.BG_SECONDARY};
  }
`;

export const TeamPickerHelper = styled(Text)`
  && {
    font-size: 11px;
    color: ${SA_COLORS.TEXT_TERTIARY};
    line-height: 1.4;
  }
`;

export const FieldErrorMsg = styled(Text)`
  && {
    font-size: 11px;
    color: ${SA_COLORS.ERROR_600};
  }
`;

export const InlineRenameError = styled(Text)`
  && {
    font-size: 11px;
    color: ${SA_COLORS.ERROR_600};
    padding: 0 12px 12px;
  }
`;

export const TeamAddAgentBtn = styled.button`
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid ${SA_COLORS.BORDER_PRIMARY};
  background: ${SA_COLORS.BG_PRIMARY};
  color: ${SA_COLORS.TEXT_PRIMARY};
  cursor: pointer;

  &:hover {
    background: ${SA_COLORS.BG_SECONDARY};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

// ── Per-agent row kebab menu ─────────────────────────────────────────
export const AgentRowMenuWrap = styled.span`
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
`;

export const AgentRowMenuPopover = styled(FlexView)`
  && {
    position: absolute;
    top: calc(100% + 4px);
    right: 0;
    min-width: 160px;
    background: ${SA_COLORS.BG_PRIMARY};
    border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 100;
    gap: 0;
  }
`;

export const AgentRowMenuItem = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-bottom: 1px solid ${SA_COLORS.BORDER_TERTIARY};
  cursor: pointer;
  text-align: left;
  font-size: 13px;
  color: ${SA_COLORS.TEXT_PRIMARY};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    background: ${SA_COLORS.BG_SECONDARY};
  }

  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const FormTextInput = styled.input`
  padding: 8px 12px;
  font-size: 13px;
  border: 1px solid ${SA_COLORS.BORDER_SECONDARY};
  background: ${SA_COLORS.BG_PRIMARY};
  color: ${SA_COLORS.TEXT_PRIMARY};
  outline: none;
  width: 100%;

  &:focus {
    border-color: ${SA_COLORS.GOLD_500};
  }

  &::placeholder {
    color: ${SA_COLORS.TEXT_TERTIARY};
  }
`;

// ── Ticket field helpers ──────────────────────────────────────────────
export const getTicketUser = ticket => ticket.customer_name || 'Unknown';
export const getTicketInitials = ticket =>
  (getTicketUser(ticket) || '--').slice(0, 2).toUpperCase();
export const getTicketId = ticket => ticket.id || '--';
export const getTicketSubject = ticket => ticket.last_message_preview || '--';
export const getTicketUnread = ticket => ticket.unread_count || 0;
export const getTicketWait = ticket => {
  const lm = ticket.last_message_at;
  if (lm) {
    const diffMs = Date.now() - lm * 1000;
    if (diffMs < 60000) return 'now';
    const mins = Math.floor(diffMs / 60000);
    if (mins < 60) return `${mins} min`;
    const hrs = Math.floor(mins / 60);
    return `${hrs}h`;
  }
  return '';
};
export const getTicketAssignedTo = ticket => ticket.agent_name || null;
export const getTicketTeam = ticket => ticket.team_name || null;

// Cross-link to the supervisor queue board. Only rendered when the
// gatekeeper admits this user, so nobody is offered a link that 403s.
